import styled from "styled-components";

export const EmptyState = styled.div`
  margin: auto;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;

  .icon {
    width: 2.5rem;
    height: 2.5rem;
    color: ${({ theme }) => theme.palette.primary.medium};
    margin-bottom: 0.5rem;
  }

  .title {
    font-size: 1.125rem;
    font-weight: 600;
    color: ${({ theme }) => theme.palette.neutral.lightest};
  }

  .subtitle {
    font-size: 0.875rem;
    color: ${({ theme }) => theme.palette.neutral.medium};
  }
`;